module.exports = __webpack_public_path__ + "img/front_length_to_waist.899019ba.png";